export default "__VITE_ASSET__c52077fe__"